// Focus the search input inside the SearchPopup overlay. The popup
// itself auto-focuses via a ref callback on mount, but we keep this
// helper around because legacy callers (HeaderNav, SummerHeader,
// home/Search, AiHomeHero) invoke it after toggling the popup open.
//
// Previously this looked up the input via a hashed SCSS-module class
// (.search > input). The SearchPopup SCSS module was removed in the
// v3 rewrite, so we now use a stable structural selector:
// the dialog itself + the first <input type="text"> inside it.
export const setFocusToSearchInput = () => {
  const input = document.querySelector<HTMLInputElement>('[role="dialog"] input[type="text"]');

  if (input) {
    input.focus();
  }
};
